import { render, staticRenderFns } from "./KloosterNavRight.vue?vue&type=template&id=4fb52f0d&scoped=true"
import script from "./KloosterNavRight.vue?vue&type=script&lang=js"
export * from "./KloosterNavRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb52f0d",
  null
  
)

export default component.exports